<template>
  <div v-if="enabled" class="space-y-1">
    <label class="block text-sm font-medium text-gray-700">Notify additional users</label>
    <CustomMultiSelect
      :model-value="modelValue"
      :options="options"
      :disabled="disabled || loading || !!error"
      placeholder="Choose GSE team members…"
      search-placeholder="Search GSE team members…"
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <p class="text-xs text-gray-500">
      {{
        loading
          ? 'Loading GSE team members…'
          : 'They will receive ticket status and completion alerts. The submitter is already included.'
      }}
    </p>
    <p v-if="error" role="alert" class="text-xs text-red-700">
      {{ error }} <button type="button" class="underline" @click="load">Retry</button>
    </p>
  </div>
</template>
<script setup>
import CustomMultiSelect from '@/components/Common/CustomMultiSelect.vue'
import { useTicketWatcherDirectory } from '@/composables/useTicketWatchers'
const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  submitterUid: { type: String, default: null },
  disabled: { type: Boolean, default: false },
})
defineEmits(['update:modelValue'])
const { enabled, loading, error, options, load } = useTicketWatcherDirectory(
  () => props.submitterUid
)
</script>
